import axios from 'axios';

export default axios.create({
  baseURL: process.env.REACT_APP_API_ANTARIE_URL,
  withCredentials: true,
  timeout: 5000, // default is `0` (no timeout) // Specifies the number of milliseconds before the request times out // If the request takes longer than `timeout`, the request will be aborted
  // headers: { Authorization: 'Client-ID loquesea' },
  // params: { parametro_uno: uno } # Puedo meter aquí los parámetros comunes a todas las queries y luego en cada query particular el resto de parámetros
});
